// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__2z0RF","label":"Input_label__2ol3A"};